// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6e7b3f2a","779":"5b9c06e1"}[chunkId] + ".chunk.js";
};